export default __webpack_public_path__ + "static/media/le_mont5.cfeec5df.jpg";